import axios from 'axios'

const util = {}
util.name = function(value) {
  if (value === undefined || value === null || value === '') {
    value = '润图逸云'
  }
  this.$store.state.projectName = value
}
util.title = function(title) {
  title = title || '润图逸云'
  window.document.title = title
}
util.baseURL = function() {
  return process.env.VUE_APP_BASE_URL
}

util.resourceURL = {
  resourceURL: process.env.VUE_APP_BASE_RESOURCE_URL
}

util.fileURL = {
  fileURL: process.env.VUE_APP_BASE_FILE_URL
}

util.uploadURL = function() {
  return process.env.VUE_APP_BASE_UPLOAD_URL
}

// axios 请求封装
axios.defaults.timeout = 600000
axios.defaults.baseURL = util.baseURL()
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=UTF-8'

util.vad = {
  /**
     * 判断是否为空
     * @param {Object} value
     */
  isBlank: function(value) {
    return value === undefined || value === null || value === ''
  },
  // 数字校验(小数,0,负数都可以)
  validateNum: function(rule, value, callback) {
    if (!value) {
      return callback()
    }
    setTimeout(() => {
      var regUrl = /^(-?\d+)(\.\d+)?$/
      if (!regUrl.test(value)) {
        callback(new Error('请输入数字'))
      } else {
        callback()
      }
    }, 100)
  },
  // 正数校验(不能为0,即大于0的数字)
  validatePositiveNum: function(rule, value, callback) {
    if (!value) {
      return callback()
    }

    setTimeout(() => {
      var regUrl = /^(\d+)(\.\d+)?$/
      if (!regUrl.test(value)) {
        callback(new Error('请输入正数'))
      } else {
        callback()
      }
    }, 100)
  },
  // 自然数校验(大于等于0)
  validateNaturalNumber: function(rule, value, callback) {
    if (!value) {
      return callback()
    }

    setTimeout(() => {
      var regUrl = /^[0-9]*$/
      if (!regUrl.test(value)) {
        callback(new Error('请输入自然数'))
      } else {
        callback()
      }
    }, 100)
  },
  // 正整数校验(不能为0)
  validatePositiveInteger: function(rule, value, callback) {
    if (!value) {
      return callback()
    }

    setTimeout(() => {
      var regUrl = /^[0-9]*[1-9][0-9]*$/
      if (!regUrl.test(value)) {
        callback(new Error('请输入正整数'))
      } else {
        callback()
      }
    }, 100)
  },
  // 手机号校验
  validatePhoneNumber: function(rule, value, callback) {
    if (!value) {
      return callback(new Error('手机号码不能为空'))
    }

    setTimeout(() => {
      var regUrl = /^1\d{10}$/
      if (!regUrl.test(value)) {
        callback(new Error('手机号码格式不正确'))
      } else {
        callback()
      }
    }, 100)
  },
  // 网址校验
  validateUrl: function(rule, value, callback) {
    // 		if (WUtil.vad.isBlank(value)) {
    // 			callback(new Error('请输入链接地址'));
    // 		};
    setTimeout(() => {
      var regUrl =
                /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)*(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/
      if (!regUrl.test(value)) {
        callback(new Error('网址格式不正确,例：http://www.xxxx.com'))
      } else {
        callback()
      }
    }, 200)
  },
  // 电话校验,含分机
  validateTelephone: function(rule, value, callback) {
    setTimeout(() => {
      //规则
      // 区号：3-4位，第一位：0，第二位：1-9，第三、四位：0-9
      // 固话：7-8位，第一位：1-9，其余：0-9
      // 分机：3-4位，0-9
      var regPhone = /^0[1-9][0-9]{1,2}-?[1-9][0-9]{6,7}(-[0-9]{3,4})?$/
      if (!regPhone.test(value)) {
        callback(new Error('请输入正确的电话号码'))
      } else {
        callback()
      }
    }, 200)
  },
  // 电话或手机校验
  validateTelephoneNumber: function(rule, value, callback) {
    if (!value) {
      callback()
    }
    setTimeout(() => {
      //规则
      // 区号：3-4位，第一位：0，第二位：1-9，第三、四位：0-9
      // 固话：7-8位，第一位：1-9，其余：0-9
      // 分机：3-4位，0-9
      // 手机：11位，第一位：1，第二位：1-9，其余：0-9
      var regPhone = /^(0[1-9][0-9]{1,2}-?[1-9][0-9]{6,7}(-[0-9]{3,4})?$)|^(1[1-9][0-9]{9}$)/
      if (!regPhone.test(value)) {
        callback(new Error('请输入正确的电话号码'))
      } else {
        callback()
      }
    }, 200)
  },
  // 特殊符号校验
  validateSpecialCharacters: function(rule, value, callback) {
    if (!value) {
      return callback()
    }
    setTimeout(() => {
      var containSpecial = RegExp(
        /[(\ )(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\')(\")(\,)(\.)(\/)(\<)(\>)(\?)(\)]+/
      )
      if (containSpecial.test(value)) {
        callback(new Error('内容不能含有特殊字符'))
      } else {
        callback()
      }
    }, 200)
  },
  // 密码校验
  validatePassword: function(rule, value, callback) {
    if (!value) {
      return callback()
    }
    setTimeout(() => {
      var regUrl = /^[a-zA-Z][a-zA-Z0-9_]*$/
      if (!regUrl.test(value)) {
        callback(new Error('以字母开头，长度在6-18之间，只能包含字母、数字和下划线'))
      } else {
        callback()
      }
    }, 200)
  },
  // 邮箱校验
  validateEmail: function(rule, value, callback) {
    if (!value) {
      return callback()
    }
    setTimeout(() => {
      var regUrl = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!regUrl.test(value)) {
        callback(new Error('请输入正确格式的邮箱号码'))
      } else {
        callback()
      }
    }, 200)
  },
  // 身份证校验
  validateIdCard: function(rule, value, callback) {
    if (!value) {
      return callback()
    }
    setTimeout(() => {
      var regUrl = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
      if (!regUrl.test(value)) {
        callback(new Error('请输入正确格式的身份证号码'))
      } else {
        callback()
      }
    }, 200)
  },
  // 大于0小于1的小数
  validateDecimal: function(rule, value, callback) {
    if (!value) {
      return callback()
    }
    setTimeout(() => {
      var regUrl = /^0\.[1-9]\d*$/
      if (!regUrl.test(value)) {
        callback(new Error('请输入0到1的小数'))
      } else {
        callback()
      }
    }, 200)
  },
  // 百分比校验
  validatePercentage: function(rule, value, callback) {
    if (!value) {
      return callback()
    }
    setTimeout(() => {
      var regUrl = /^(100|[1-9]?\d(\.\d\d?)?)%$/
      if (!regUrl.test(value)) {
        callback(new Error('请输入正确的百分比格式'))
      } else {
        callback()
      }
    }, 200)
  },
  // 整数校验0-100
  validatePercent: function(rule, value, callback) {
    if (!value) {
		    return callback()
    }
    var regUrl = /^(?:0|[1-9][0-9]?|100)$/
    if (!regUrl.test(value)) {
		    callback(new Error('请输入0-100的整数'))
    } else {
		    callback()
    }
  },
  // 价格校验2位小数
  validatePrice: function(rule, value, callback, digits) {
    if (!value) {
      callback()
    }
    setTimeout(() => {
      var regUrl = digits ? /(^-?[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.\d{1,6}?$)/ : /(^-?[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.\d{1,2}?$)/
      if (!regUrl.test(value)) {
        callback(new Error('请输入正确格式的金额(x.xx;x.x;x)'))
      } else {
        callback()
      }
    }, 100)
  },
  // 传真校验
  validateFax: function(rule, value, callback) {
    if (!value) {
      callback()
    }
    if (value != undefined && value != '') {
      var regUrl = /^(\d{3,4}-)?\d{7,8}$/
      if (!regUrl.test(value)) {
        callback(new Error('请输入正确格式的传真'))
      } else {
        callback()
      }
    }
  },

  // 银行账号验证(1-30位数字)
  validateTaxBankAccount: function(rule, value, callback) {
    if (!value) {
      return callback()
    }

    setTimeout(() => {
      value = value.replace(/\s+/g,"");
      var regUrl = /^\d{1,30}$/
      if (!regUrl.test(value)) {
        callback(new Error('银行账号必须是1~30位的数字'))
      } else {
        callback()
      }
    }, 100)
  },
}

// 格式化时间
util.formatTime = function(time, format) {
  if (!time) {
    return ''
  }
  var time = time || new Date()
  var de = new Date(time),
    yy = de.getFullYear(),
    mm = parseInt(de.getMonth()) + 1 < 10 ? '0' + (parseInt(de.getMonth()) + 1) : parseInt(de.getMonth()) + 1,
    dd = de.getDate() < 10 ? '0' + de.getDate() : de.getDate(),
    h = de.getHours() < 10 ? '0' + de.getHours() : de.getHours(),
    m = de.getMinutes() < 10 ? '0' + de.getMinutes() : de.getMinutes(),
    s = de.getSeconds() < 10 ? '0' + de.getSeconds() : de.getSeconds()
  switch (format) {
    case 'yy-mm-dd hh:mm:ss':
      return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m + ':' + s
    case 'yy-mm-dd 00:00:00':
      return yy + '-' + mm + '-' + dd + ' 00:00:00'
    case 'yy-mm-dd 23:59:59':
      return yy + '-' + mm + '-' + dd + ' 23:59:59'
    case 'yy-mm':
      return yy + '-' + mm
    case 'yyyy-MM-dd':
      return yy + '-' + mm + '-' + dd
    default:
      return yy + '-' + mm + '-' + dd
  }
}

/**
 * 日期函数
 */
util.date = {
  strToDate: function(str) {
    var fullDate = str.split('-')
    return new Date(fullDate[0], fullDate[1] - 1, fullDate[2], 0, 0, 0)
  },
  formatDate: function(date, format) {
    var v = ''
    if (typeof date === 'string' || typeof date !== 'object') {
      return
    }
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var day = date.getDate()
    var hour = date.getHours()
    var minute = date.getMinutes()
    var second = date.getSeconds()
    var weekDay = date.getDay()
    var ms = date.getMilliseconds()
    var weekDayString = ''

    if (weekDay == 1) {
      weekDayString = '星期一'
    } else if (weekDay == 2) {
      weekDayString = '星期二'
    } else if (weekDay == 3) {
      weekDayString = '星期三'
    } else if (weekDay == 4) {
      weekDayString = '星期四'
    } else if (weekDay == 5) {
      weekDayString = '星期五'
    } else if (weekDay == 6) {
      weekDayString = '星期六'
    } else if (weekDay == 7) {
      weekDayString = '星期日'
    }

    v = format
    // Year
    v = v.replace(/yyyy/g, year)
    v = v.replace(/YYYY/g, year)
    v = v.replace(/yy/g, (year + '').substring(2, 4))
    v = v.replace(/YY/g, (year + '').substring(2, 4))

    // Month
    var monthStr = ('0' + month)
    v = v.replace(/MM/g, monthStr.substring(monthStr.length - 2))

    // Day
    var dayStr = ('0' + day)
    v = v.replace(/dd/g, dayStr.substring(dayStr.length - 2))

    // hour
    var hourStr = ('0' + hour)
    v = v.replace(/HH/g, hourStr.substring(hourStr.length - 2))
    v = v.replace(/hh/g, hourStr.substring(hourStr.length - 2))

    // minute
    var minuteStr = ('0' + minute)
    v = v.replace(/mm/g, minuteStr.substring(minuteStr.length - 2))

    // Millisecond
    v = v.replace(/sss/g, ms)
    v = v.replace(/SSS/g, ms)

    // second
    var secondStr = ('0' + second)
    v = v.replace(/ss/g, secondStr.substring(secondStr.length - 2))
    v = v.replace(/SS/g, secondStr.substring(secondStr.length - 2))

    // weekDay
    v = v.replace(/E/g, weekDayString)
    return v
  },
  chsDay: ['日', '一', '二', '三', '四', '五', '六']
}

// 默认地址坐标
util.mapCoordinate = {
  lng: 116.404,
  lat: 39.915,
  address: '北京市东城区'
}

export default util

export const objEqual = (obj1, obj2) => {
  const keysArr1 = Object.keys(obj1)
  const keysArr2 = Object.keys(obj2)
  if (keysArr1.length !== keysArr2.length) {
    return false
  } else if (keysArr1.length === 0 && keysArr2.length === 0) {
    return true
  } /* eslint-disable-next-line */
    else {
    return !keysArr1.some(key => obj1[key] != obj2[key])
  }
}
export const routeEqual = (route1, route2) => {
  const params1 = route1.params || {}
  const params2 = route2.params || {}
  const query1 = route1.query || {}
  const query2 = route2.query || {}
  return (route1.name === route2.name) && objEqual(params1, params2) && objEqual(query1, query2)
}



// WEBPACK FOOTER //
// ./src/lib/util.js